import React, { useState, useEffect } from 'react';
import { Check, ArrowRight } from 'lucide-react';
import Navigation from '../components/Navigation';

const MentorshipPage = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
    window.scrollTo(0, 0);
  }, []);

  const mentorshipFeatures = [
    "Digital Wealth Academy",
    "Weekly coaching",
    "Brand strategy",
    "Content roadmap",
    "Accountability"
  ];

  const vipFeatures = [
    "Everything in Mentorship",
    "Website setup",
    "AI automations",
    "Email systems",
    "Funnel setup",
    "Launch support"
  ];

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#ffffff' }}>
      <Navigation />
      
      {/* Hero Section */}
      <section className="pt-32 pb-20 px-8">
        <div className="max-w-4xl mx-auto text-center">
          <p 
            className="text-xs tracking-[0.3em] mb-6"
            style={{ 
              color: '#8b7355',
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
              transition: 'all 0.8s ease-out'
            }}
          >
            MENTORSHIP
          </p>
          
          <h1 
            className="text-3xl md:text-4xl lg:text-5xl font-light mb-6"
            style={{ 
              fontFamily: "'Playfair Display', serif", 
              color: '#1a1a1a',
              lineHeight: '1.2',
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
              transition: 'all 0.8s ease-out 0.1s'
            }}
          >
            Build the business that gives you
            <br />
            <span className="italic" style={{ color: '#8b7355' }}>more choices.</span>
          </h1>
          
          <p 
            className="text-base font-light max-w-2xl mx-auto"
            style={{ 
              color: '#666',
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
              transition: 'all 0.8s ease-out 0.2s'
            }}
          >
            Private mentorship designed to help you build the confidence, systems and online income to create a life on your own terms.
          </p>
        </div>
      </section>

      {/* Pricing Cards */}
      <section className="py-20 px-8">
        <div className="max-w-5xl mx-auto">
          <div className="grid md:grid-cols-2 gap-8">
            {/* Mentorship Card */}
            <div 
              className="p-10 rounded-lg transition-all duration-500 hover:scale-[1.02]"
              style={{ 
                backgroundColor: '#ffffff',
                boxShadow: '0 4px 20px rgba(0,0,0,0.06)',
                opacity: isVisible ? 1 : 0,
                transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
                transition: 'all 0.8s ease-out 0.3s'
              }}
            >
              <p 
                className="text-xs tracking-[0.2em] mb-4"
                style={{ color: '#8b7355' }}
              >
                FOUNDATION
              </p>
              
              <h2 
                className="text-2xl font-light mb-2"
                style={{ fontFamily: "'Playfair Display', serif", color: '#1a1a1a' }}
              >
                Break Free & Build
              </h2>
              <p className="text-sm font-light mb-6" style={{ color: '#666' }}>Mentorship</p>
              
              <div className="mb-8">
                <span 
                  className="text-4xl font-light"
                  style={{ fontFamily: "'Playfair Display', serif", color: '#1a1a1a' }}
                >
                  $500
                </span>
              </div>
              
              <div className="space-y-4 mb-10">
                {mentorshipFeatures.map((feature, index) => (
                  <div key={index} className="flex items-center gap-3">
                    <Check size={16} style={{ color: '#8b7355' }} />
                    <span className="text-sm font-light" style={{ color: '#555' }}>{feature}</span>
                  </div>
                ))}
              </div>
              
              <a
                href="https://stan.store/FarzeenDigitalWealth"
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full py-4 text-center text-sm tracking-wider font-light rounded transition-all duration-300 hover:opacity-90"
                style={{ 
                  backgroundColor: '#1a1a1a',
                  color: '#ffffff'
                }}
              >
                GET STARTED
              </a>
            </div>

            {/* VIP Card */}
            <div 
              className="p-10 rounded-lg transition-all duration-500 hover:scale-[1.02] relative overflow-hidden"
              style={{ 
                backgroundColor: '#1a1a1a',
                boxShadow: '0 4px 30px rgba(0,0,0,0.15)',
                opacity: isVisible ? 1 : 0,
                transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
                transition: 'all 0.8s ease-out 0.4s'
              }}
            >
              {/* Accent line */}
              <div 
                className="absolute top-0 left-0 right-0 h-1"
                style={{ backgroundColor: '#8b7355' }}
              />
              
              <p 
                className="text-xs tracking-[0.2em] mb-4"
                style={{ color: '#8b7355' }}
              >
                PREMIUM
              </p>
              
              <h2 
                className="text-2xl font-light mb-2"
                style={{ fontFamily: "'Playfair Display', serif", color: '#ffffff' }}
              >
                VIP Systems Build
              </h2>
              <p className="text-sm font-light mb-6" style={{ color: 'rgba(255,255,255,0.6)' }}>Done-With-You</p>
              
              <div className="mb-8">
                <span 
                  className="text-4xl font-light"
                  style={{ fontFamily: "'Playfair Display', serif", color: '#ffffff' }}
                >
                  $1,000
                </span>
              </div>
              
              <div className="space-y-4 mb-10">
                {vipFeatures.map((feature, index) => (
                  <div key={index} className="flex items-center gap-3">
                    <Check size={16} style={{ color: '#8b7355' }} />
                    <span className="text-sm font-light" style={{ color: 'rgba(255,255,255,0.8)' }}>{feature}</span>
                  </div>
                ))}
              </div>
              
              <a
                href="https://stan.store/FarzeenDigitalWealth"
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full py-4 text-center text-sm tracking-wider font-light rounded transition-all duration-300 hover:opacity-90"
                style={{ 
                  backgroundColor: '#8b7355',
                  color: '#ffffff'
                }}
              >
                APPLY NOW
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* What's Included Detail */}
      <section className="py-20 px-8" style={{ backgroundColor: '#fafafa' }}>
        <div className="max-w-3xl mx-auto text-center">
          <p 
            className="text-xs tracking-[0.3em] mb-6"
            style={{ color: '#8b7355' }}
          >
            THE EXPERIENCE
          </p>
          
          <h2 
            className="text-2xl md:text-3xl font-light mb-8"
            style={{ fontFamily: "'Playfair Display', serif", color: '#1a1a1a' }}
          >
            More than a course.
            <br />
            <span className="italic" style={{ color: '#8b7355' }}>A transformation.</span>
          </h2>
          
          <p 
            className="text-base font-light leading-relaxed mb-12"
            style={{ color: '#666' }}
          >
            This isn't about information overload. It's about clarity, strategy, and having someone in your corner who's already built what you're building. Together, we'll create a business that works for your life—not the other way around.
          </p>
          
          <a
            href="/"
            className="inline-flex items-center gap-2 text-sm font-light transition-opacity hover:opacity-60"
            style={{ color: '#8b7355' }}
          >
            Take the Chapter Quiz to find your fit
            <ArrowRight size={16} />
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-12 px-8" style={{ backgroundColor: '#1a1a1a' }}>
        <div className="max-w-4xl mx-auto text-center">
          <p 
            className="text-sm font-light italic mb-4"
            style={{ fontFamily: "'Playfair Display', serif", color: '#ffffff' }}
          >
            Farzeen Khan
          </p>
          <p className="text-xs" style={{ color: 'rgba(255,255,255,0.4)' }}>
            © {new Date().getFullYear()} Break Free & Build™. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default MentorshipPage;
